import { render, staticRenderFns } from "./typesproduct.vue?vue&type=template&id=3e77d918&"
import script from "./typesproduct.vue?vue&type=script&lang=js&"
export * from "./typesproduct.vue?vue&type=script&lang=js&"
import style0 from "./typesproduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports